import {GoogleGenAI} from '@google/genai';
const TOKEN_GPT = process.env.REACT_APP_TOKEN_GPT;
async function sendMessage(teksUser, summaryUser) {
  try {
    const genAI = new GoogleGenAI({apiKey: TOKEN_GPT});
    let prompt = `Asisten LacaKas. Jawab singkat (<50 kata), fokus keuangan pribadi. Jika off-topic, tolak sopan`;
    if (teksUser.length >= 10){
      prompt += `Data Keuangan User:
${summaryUser}
Pertanyaan User:
${teksUser}`;
    }
    const result = await genAI.models.generateContent({
      model: "gemini-2.5-flash-lite",
      contents: prompt
    });
    return result.text;
    
  } catch (err) {
    console.error("❌ Error AI:", err);  
    return "Maaf, terjadi kesalahan saat memproses permintaan Anda.";
  }
}
export default sendMessage;